<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">
        <Navigation />
        <div class="bg_box">
            <div class="noneBox"></div>
            <div class="box">
                <p class="back" @click="$router.back()">返回</p>
                <img src="../../assets/wordOp/ShortVideoTitle.png" alt="" class="title">
                <div class="ct_box">
                    <div class="form_box">
                        <div class="select_box flex">
                            <p class="title_1">类型</p>
                            <el-select v-model="form.type" placeholder="请选择">
                                <el-option v-for="(item, index) in selectList" :key="index" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="text_box flex">
                            <p class="title_1">标题</p>
                            <el-input v-model="form.business" placeholder="如:故宫一日游"></el-input>
                        </div>
                        <div class="text_box flex">
                            <p class="title_1">核心内容描述</p>
                            <el-input v-model="form.kernel" placeholder="如:编写内容的核心简述"></el-input>
                        </div>
                        <div class="text_box flex">
                            <p class="title_1">关键词</p>
                            <el-input v-model="form.keyword" placeholder="如:有趣的建筑"></el-input>
                        </div>
                        <button class="submit" @click="FileData">生成内容</button>
                        <el-input resize="none" readonly type="textarea" :rows="13"
                            v-model="contentData.output_content">
                        </el-input>
                        <button class="copy" @click="copy()">复制内容</button>
                    </div>
                    <wordNav />

                    <aiNum title="计费规则：1000tokens = 0.9元，" text="1000tokens在700-750字左右" :visible="aiNumShow"
                        @close="aiNumShow = false" @postData="postData" />
                    <aiPoup :visible="aiPoupShow" @close="aiPoupShow = false" />
                </div>
            </div>
        </div>
        <footerBot />

    </div>
</template>

<script>
import wordNav from '../../components/wordNav.vue'
import { curlPost } from '@/api/request'
export default {
    name: '',
    created() { },
    mounted() { },
    components: {
        wordNav
    },
    data() {
        return {
            form: {
                type: '',
                business: '',
                keyword: '',
                kernel: '',
            },
            fullscreenLoading: false,
            contentData: {}, //内容
            selectList: ['美食', '自然', '专题', '历史', '生活', '宣传', '其他'],
            aiNumShow: false,
            aiPoupShow: false,

        }
    },
    methods: {
        // 获取用户信息
        getUserInfo() {
            this.curlGet('/api/user/info').then((res) => {
                if (res.data.code) {
                    this.$user_info = res.data.data
                    this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
                }
            })
        },
        copy() {
            //参数是复制的内容
            //.then()中的函数是复制成功和复制失败的两个回调函数
            this.$copyText(this.contentData.output_content).then(
                (e) => {

                    return this.$message({
                        message: '复制成功',
                        type: 'success',
                        offset: 80,
                    });
                },
                (err) => {
                    return this.$message({
                        message: '复制失败',
                        type: 'warning',
                        offset: 80,
                    });
                }
            );
        },
        FileData() {
            if (this.form.type == '') {
                return this.$message({
                    message: '请输入平台',
                    type: 'warning'
                });
            }
            if (this.form.business == '') {
                return this.$message({
                    message: '请输入标题',
                    type: 'warning'
                });
            }
            if (this.form.kesword == '') {
                return this.$message({
                    message: '请输入关键字',
                    type: 'warning'
                });
            }
            if (this.$user_info.money <= 0) {
                this.aiPoupShow = true
            } else {
                this.aiNumShow = true
            }

        },
        postData() {
            this.aiNumShow = false
            this.fullscreenLoading = true
            curlPost('/file/shortVideo_create', {
                type: this.form.type,
                business: this.form.business,
                keyword: this.form.keyword,
                mobile: this.$user_info.mobile,
                kernel: this.form.kernel,

            }).then(res => {
                if (res.data.code) {
                    this.contentData = res.data.data
                    // 扣费
                    this.curlPost('/api/users/money_log/spend', {
                        ai_id: res.data.data.id,
                        amount: res.data.data.money,
                    }).then(res => {
                        if (res.data.code) {
                            this.getUserInfo()

                        }
                    })
                } else {
                    return this.$message.error(res.msg);
                }
                this.fullscreenLoading = false
            })
        }
    },
}
</script>

<style lang=scss scoped>
@import '../../scss/EnterpriseProfile.scss'
</style>